import { render } from "./ChristmasOfferChart.vue?vue&type=template&id=66a5b046&scoped=true"
import script from "./ChristmasOfferChart.vue?vue&type=script&lang=js"
export * from "./ChristmasOfferChart.vue?vue&type=script&lang=js"

import "./ChristmasOfferChart.vue?vue&type=style&index=0&id=66a5b046&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a5b046"],['__file',"src/components/christmas-offer/ChristmasOfferChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66a5b046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66a5b046', __exports__)) {
    console.log('reload')
    api.reload('66a5b046', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferChart.vue?vue&type=template&id=66a5b046&scoped=true", () => {
    console.log('re-render')
    api.rerender('66a5b046', render)
  })

}


export default __exports__